@if (displayLabel) {
  <p-floatlabel variant="on" class="tax-code-select-floatlabel">
    <ng-container [ngTemplateOutlet]="taxSelectTpl" />
    <label [for]="selectInputId">Tax</label>
  </p-floatlabel>
} @else {
  <ng-container [ngTemplateOutlet]="taxSelectTpl" />
}

<ng-template #taxSelectTpl>
  <p-select
    [inputId]="selectInputId"
    [options]="taxCodeOptions()"
    optionLabel="label"
    optionValue="value"
    [class]="fullWidth || valueOutput !== 'percentage' ? 'w-full' : 'w-auto'"
    appendTo="body"
    [showClear]="true"
    [ngModel]="value"
    (ngModelChange)="onTaxCodeChange($event)"
    [disabled]="isDisabled"
  >
    <ng-template let-option pTemplate="item">
      <span>{{ option.label }}</span>
      @if (option.is_default) {
        &nbsp;<p-badge value="Default" />
      }
    </ng-template>
    <ng-template let-selectedOption pTemplate="selectedItem">
      @if (selectedOption) {
        @if (valueOutput === "percentage") {
          @if (selectedOption.value === null) {
            <span>None</span>
          } @else {
            <span>{{ selectedOption.percentage }}%</span>
          }
        } @else {
          <span>{{ selectedOption.label }}</span>
        }
      }
    </ng-template>
  </p-select>
</ng-template>
